module.exports = __webpack_public_path__ + "static/media/sound-bubble-pause.22eb1e8f.png";